<template>
  <FormElement :name="name" :label="label" :value="formatValue(value)">
    <slot slot="tooltip" name="tooltip"></slot>
    <input slot="input" @input="onChange" :name="name" type="checkbox" :checked="value" />
  </FormElement>
</template>

<script>
import Tooltip from './Tooltip.vue'
import FormElement from './FormElement.vue'

export default {
  name: 'FormCheckbox',
  components: {
    FormElement
  },
  props: {
    label: {
      required: false,
      type: String
    },
    formatValue: {
      required: false,
      type: Function,
      default: v => v
    },
    name: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Number | String
    }
  },
  methods: {
    onChange: function(e) {
      this.$emit('update:value', e.target.checked)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type=checkbox] {
  position: relative;
  appearance: none;
  outline: none;
  width: 50px;
  height: 30px;
  background-color: white;
  border: 1px solid #D9DADC;
  border-radius: 50px; box-shadow: inset -20px 0 0 0 #ccc;
  transition-duration: 200ms;
}

input[type=checkbox]:after {
  content: "";
  position: absolute;
  top: 1px; left: 1px;
  width: 26px; height: 26px;
  background-color: transparent;
  border-radius: 50%; box-shadow: 2px 4px 6px rgba(0,0,0,0.2);
}

input[type=checkbox]:checked {
  border-color: #4ED164;
  box-shadow: inset 20px 0 0 0 #4ED164;
}

input[type=checkbox]:checked:after {
  left: 20px;
  box-shadow: -2px 4px 3px rgba(0,0,0,0.05);
}

</style>

